

























import Vue from "vue";
import AppConsts from "../../../../lib/appconst";

export default Vue.extend({
  name: "About",
  props: {
    showEditor: Boolean
  },
  data() {
    return {
      version: AppConsts.version,
      environment: AppConsts.environment,
      lastUpdate: AppConsts.lastUpdate
    };
  },
  computed: {
    showModal(): any {
      return this.showEditor;
    }
  },
  watch: {
    showModal(newVal) {}
  },
  methods: {}
});
